import { render } from "./FolderNode.vue?vue&type=template&id=22fbd88a"
import script from "./FolderNode.vue?vue&type=script&lang=js"
export * from "./FolderNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__